import chooseUrl from './choose.html';
export default function ChooseService(Authentication, $uibModal, $sce, $sanitize) {
  'ngInject';

  const service = this;

  service.ask = function ask(question, buttons, title, options = {}, headerIcon) {
    return $uibModal
      .open({
        size: '620',
        templateUrl: chooseUrl,
        backdrop: 'static',
        controller($scope) {
          'ngInject';

          $scope.question = $sce.trustAsHtml($sanitize(question));
          $scope.buttons = buttons;
          $scope.title = title || 'Please choose';
          $scope.headerIcon = headerIcon || null;
          Object.assign($scope, options);

          $scope.exc = function exc(button) {
            if ('premiumRequired' in button) {
              const isBlocked =
                typeof button.premiumRequired !== 'boolean'
                  ? !Authentication.isOrgFeatureEnabled(button.premiumGuard)
                  : !Authentication.user.org.isPremium;
              if (isBlocked) {
                return false;
              }
            }

            if (button.handler) {
              button.handler();
            }

            return true;
          };
        },
      })
      .result.ignoreCancel();
  };
}
